<template>
  <div class="loan-from">
    <!--导航部分-->
    <div class="nav" style="padding-bottom: 56px;">
      <van-nav-bar
              :title="$route.query.name"
              fixed
              left-arrow
              @click-left="onClickLeft"
      />
    </div>
    <!--输入框-->
   <!-- <van-image width="100%" src="http://image.benjiar.com/s1s.jpg" /> -->
    <div style="margin: 23px 16px 10px 16px;">
      <van-cell-group>
        <van-field v-model="loan.name" label="姓名" placeholder="请输入真实姓名" />
      </van-cell-group>

      <van-cell-group>
        <van-field v-model="loan.phone" label="手机号" placeholder="请输入手机号" />
      </van-cell-group>

      <div class="van-cell van-cell--center van-field">
        <div class="van-cell__title van-field__label">
          <span>验证码</span>
        </div>
        <div class="van-cell__value van-field__value">
          <div class="van-field__body">
            <input type="text" v-model="loan.sms" placeholder="请输入短信验证码" class="van-field__control">

            <div class="van-field__button" v-show="sendCode">
              <button class="van-button van-button--primary van-button--small" @click=getCode>
                <div class="van-button__content">
                  <span class="van-button__text">发送验证码</span>
                </div>
              </button>
            </div>

            <div class="van-field__button" v-show="!sendCode">
              <button class="van-button van-button--primary van-button--small" @click=getCode>
                <div class="van-button__content">
                  <span class="van-button__text">{{auth_time}}秒</span>
                </div>
              </button>
            </div>

          </div>
        </div>
      </div>

      <van-cell-group>
        <van-field v-model="loan.card" label="身份证号" placeholder="请输入身份证号码" />
      </van-cell-group>
      <div style="width: 80%; margin:10px auto 0 auto;">
        <van-button type="primary" block @click="goApply">立即申请</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState,mapActions} from 'vuex'
var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
export default {
    'name': 'LoanFrom',
    data() {
        return {
          loan:{
            name:'',
            phone:'',
            card:'',
            sms:''
          },
          // 配置验证码
          sendCode: true,
          auth_time: 0
        };
    },
    computed: {
        ...mapState({
            city: state => state.cityData.city,
            win: state => state.win.win
        })
    },
    methods: {
      ...mapActions(['requestWin','requestArchive']),
        onClickLeft() {
            this.$router.push({path: '/loan/channel'});
        },
        goApply() {
           // 验证判断区
           if (this.loan.name === '') {
              this.$toast.fail({
                duration: 600,
                message: "姓名必填"
              });
                return false
            };
           if (this.loan.phone === '') {
              this.$toast.fail({
                duration: 600,
                message: "手机号必填"
              });
                return false
            };
            if (!myreg.test(this.loan.phone)) {
               this.$toast.fail({
                 duration: 600,
                 message: "手机号格式不对"
               });
                 return false
             };
             if (this.loan.sms === '') {
                this.$toast.fail({
                  duration: 600,
                  message: "验证码必填"
                });
                  return false
              };
             if (this.loan.card === '') {
                this.$toast.fail({
                  duration: 600,
                  message: "身份证号必填"
                });
                  return false
              };

              const fromToast = this.$toast.loading({
                   mask: true,
                   message: '正在提交中...',
                   duration:0
               });

            let data = {
                   accessToken: this.win.data.accessToken,
                   applyLoanType: "03",
                   channel: "2148",
                   customers: [{
                       customerType:'01',
                       applicantRelation:'07',
                       name: this.loan.name,
                       mobile: this.loan.phone
                   }],
                   manager: {
                     applyCityCode:'110100',
                     applyCity:this.city,
                   },
                   orderId: "11111113",
                   partnerNo: "1054",
                   products: [{
                       isMainProduct:'Y',
                       applyAmount:'100000',
                       repayLimit:'12'
                   }],
                   rmk: "qichezhijia",
                   vehicles: [{
                       isBusinessVehicle:'Y',
                       dealPrice:28966,
                       customVehicleModel:'aaa',
                       isMianCar:'Y'
                   }]
               };

               this.requestArchive({"thit":this,"data":data,"fromToast":fromToast});

        },
        getCode() {
          if (this.loan.phone=== ''){
              this.$toast.fail({
                duration: 800,
                message: "手机号必填"
              });
              return false;
          };

          if (!myreg.test(this.loan.phone)) {
              this.$toast.fail({
                duration: 800,
                message: "手机号格式不对"
              });
              return false;
          };

          this.sendCode = false;
          this.auth_time = 60;

          // Vuex 传递短信验证码，并且发送赢TOKEN
          this.requestWin({"thit":this});

          let auth_time = setInterval(() =>{
              this.auth_time--;
              if(this.auth_time<=0){
                  this.sendCode = true;
                  clearInterval(auth_time);
              }
          },1000);

        }
    },
    mounted() {

    }
};
</script>

<style scoped>
.loan-from >>> .van-nav-bar {
  z-index: 9;
  background-color: #ff8917;
  padding-top: 6px;
}
.loan-from >>> .van-nav-bar__text {
  color: #fff;
}
.loan-from >>> .van-nav-bar__title {
  color: #fff;
}
.loan-from >>> .van-nav-bar .van-icon {
  color: #fff;
}
.loan-from >>> .van-button--primary {
  color: #fff;
  background-color: #ff8917;
  border: 0.02667rem solid #ff8917;
}
</style>
